import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';

class AddCRMMappingModalConfirm extends React.Component {

    render() {
        return (
            <Modal isOpen={this.props.isOpen} className={"modal-content " + this.props.className}>
                <ModalHeader>{this.props.contentHeader}</ModalHeader>
                <ModalBody>{this.props.contentBody}</ModalBody>
                <ModalFooter>
                    {this.props.saveCloseCallback && <Button color="primary" size="sm" onClick={this.props.saveCloseCallback}>{this.props.saveCloseText}</Button>}
                    {this.props.cancelCallback && <Button color="backward" size="sm" onClick={this.props.cancelCallback}>{this.props.cancelText}</Button>}
                </ModalFooter>
            </Modal>
        );
    }
}

// PropTypes: For prop validation
AddCRMMappingModalConfirm.propTypes = {
    isOpen: PropTypes.bool,
    contentHeader: PropTypes.string,
    contentBody: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    confirmCallback: PropTypes.func,
    cancelCallback: PropTypes.func
};

// PropTypes: Defaulting value for optional props
AddCRMMappingModalConfirm.defaultProps = {
    isOpen: false,
    confirmText: 'Yes',
    cancelText: 'No'
};


export default withRouter(AddCRMMappingModalConfirm);
